// extracted by mini-css-extract-plugin
module.exports = {"LessonViewerContainer":"LessonViewer_LessonViewerContainer__i2cJx","LessonViewerTabsContainer":"LessonViewer_LessonViewerTabsContainer__1F1Va"};